export const trackingStates = {
  started: 'started',
  starting: 'starting',
  stopped: 'stopped',
  stopping: 'stopping',
  onHold: 'onhold'
};
